export function toCents($) {
    if ($ === null || $ === undefined) {
        return undefined;
    }
    const number = Number(($ * 100).toFixed(0));
    if (isNaN(number)) {
        return undefined;
    }
    return number;
}
export function toDecimal($) {
    if ($ === null || $ === undefined) {
        return undefined;
    }
    const number = Number(($ / 100).toFixed(2));
    if (isNaN(number)) {
        return undefined;
    }
    return number;
}
export function toFormattedString(num) {
    if (num === undefined) {
        return undefined;
    }
    const number = Number(num);
    if (isNaN(number)) {
        return num;
    }
    return number.toLocaleString();
}
export function getOrdinalSuffix(day) {
    if (day < 1 || day > 31) {
        throw new Error('Day must be between 1 and 31');
    }
    const tens = Math.floor(day / 10);
    const units = day % 10;
    if (tens === 1) {
        return 'th';
    }
    else {
        switch (units) {
            case 1:
                return 'st';
            case 2:
                return 'nd';
            case 3:
                return 'rd';
            default:
                return 'th';
        }
    }
}
//# sourceMappingURL=numberUtils.js.map